import doc from "./driveImg/doc.svg"
import pdf from "./driveImg/pdf.svg"
import php from "./driveImg/php.svg"
import ppt from "./driveImg/ppt.svg"
import rar from "./driveImg/rar.svg"
import txt from "./driveImg/txt.svg"
import xls from "./driveImg/xls.svg"
import zip from "./driveImg/zip.svg"

import folder from "./driveImg/folder.svg"
import groupFolder from "./driveImg/groupFolder.svg"
import image from "./driveImg/image.svg"
import unknown from "./driveImg/unknown.svg"
import video from "./driveImg/video.svg"
import config from "./driveImg/config.svg"

const DriveImages = {
    doc,
    pdf,
    php,
    ppt,
    rar,
    txt,
    xls,
    zip,

    folder,
    groupFolder,
    image,
    unknown,
    video,
    config,
}
export default DriveImages
